export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return
  const css = `
.el-dialog { --el-dialog-padding-primary: 0.4rem !important; border-radius: 0 !important; }
.el-dialog__title { color: #121212 !important; font-size: 0.24rem !important; font-weight: 600 !important; }
.el-dialog__headerbtn { width: 0.4rem !important; height: 0.4rem !important; display:inline-flex !important; align-items:center !important; justify-content:center !important; right:0.1rem !important; top:0.1rem !important; }
.el-dialog__headerbtn .el-dialog__close { color: #121212 !important; font-size: 0.3rem !important; }
.el-message { z-index: 4000 !important; }
`
  const styleEl = document.createElement('style')
  styleEl.setAttribute('data-source', 'element-plus-dialog')
  styleEl.textContent = css
  document.head.appendChild(styleEl)
})
